const EDOCS_API_BASE =
    import.meta.env.VITE_EDOCS_API_URL || 'http://localhost:4002/api/v1';

const ENV = {
    APP_NAME: import.meta.env.VITE_APP_NAME || 'Dispatchly | e-Documents',

    API_URL: EDOCS_API_BASE,

    FRONT_FACING_URL: import.meta.env.VITE_FRONT_FACING_URL || '',
    BASE_URL: import.meta.env.VITE_BASE_URL || '',

    NODE_ENV: import.meta.env.MODE || 'development',
    PORT: import.meta.env.PORT || 5174,
    HOST: import.meta.env.HOST || '0.0.0.0',
    SSL: import.meta.env.SSL || false,
    SSL_KEY: import.meta.env.SSL_KEY || '',

    /**
     * Client-gated sign-in (Confirm Identity)
     * If set, only these values are accepted on the Sign-in screen.
     */
    CLIENT_EMAIL: import.meta.env.VITE_CLIENT_EMAIL || '',
    CLIENT_PHONE: import.meta.env.VITE_CLIENT_PHONE || '',

    /** Optional: shown on Confirm identity (agent strip + contact actions) */
    AGENT_NAME: import.meta.env.VITE_AGENT_NAME || '',
    AGENT_PHONE: import.meta.env.VITE_AGENT_PHONE || '',
    AGENT_EMAIL: import.meta.env.VITE_AGENT_EMAIL || ''
};

export { ENV };
